import { GetAllSitesRequest, GetNetworkCombosRequest, GetActivityTitlesRequest, GetFeatureTypesRequest } from '../requers/siteRequest';
import { setFeatureColors } from '../utils/siteStatus';

export const SITES_LOADING   = 'SITES_LOADING';
export const SITES_SUCCESS   = 'SITES_SUCCESS';
export const SITES_ERROR     = 'SITES_ERROR';
export const FILTERS_UPDATE  = 'FILTERS_UPDATE';
export const COMBOS_SUCCESS  = 'COMBOS_SUCCESS';
export const TITLES_SUCCESS  = 'TITLES_SUCCESS';
export const TYPES_SUCCESS   = 'TYPES_SUCCESS';

let _fetchSeq = 0;

export const loadNetworkCombos = () => async (dispatch) => {
	try {
		const res = await GetNetworkCombosRequest();
		dispatch({ type: COMBOS_SUCCESS, payload: res.data });
	} catch (err) {
		console.error('[loadNetworkCombos]', err?.message);
	}
};

// Type (Feature) list + colours — from TrackerFeature (Id/Name/Color), same
// endpoint/lookup the Activity Tracker module uses. The backend already filters
// IsActive=1 and orders by SortOrder, so the response arrives ready to use.
// setFeatureColors() primes getFeatureColor()'s lookup so the map/legend pick up
// DB-defined colours instead of the hardcoded FEATURE_COLORS fallback.
export const loadFeatureTypes = () => async (dispatch) => {
	try {
		const res   = await GetFeatureTypesRequest();
		const types = (res.data || []).map((t) => ({
			id:    t.id    ?? t.Id,
			name:  t.name  ?? t.Name,
			color: t.color ?? t.Color,
		}));
		setFeatureColors(types);
		dispatch({ type: TYPES_SUCCESS, payload: types });
	} catch (err) {
		console.error('[loadFeatureTypes]', err?.message);
	}
};

export const loadAllSites = () => async (dispatch, getState) => {
	const { filters } = getState().sites;
	const token = ++_fetchSeq;
	dispatch({ type: SITES_LOADING, token });
	try {
		const res = await GetAllSitesRequest(filters);
		dispatch({ type: SITES_SUCCESS, payload: res.data, token });
	} catch (err) {
		if (_fetchSeq !== token) return;
		const msg = err?.response?.data?.message || err?.response?.statusText || err?.message || 'Unknown error';
		dispatch({ type: SITES_ERROR, payload: `${err?.response?.status || ''} ${msg}`, token });
	}
};

export const loadActivityTitles = () => async (dispatch, getState) => {
	const { filters } = getState().sites;
	try {
		const res = await GetActivityTitlesRequest(filters);
		dispatch({ type: TITLES_SUCCESS, payload: res.data || [] });
	} catch (err) {
		console.error('[loadActivityTitles]', err?.message);
	}
};

// Apply button + activity status toggle.
// Reloads both sites and titles with the new filters.
export const applyFilters = (newFilters) => (dispatch) => {
	dispatch({ type: FILTERS_UPDATE, payload: newFilters });
	dispatch(loadAllSites());
	dispatch(loadActivityTitles());
};